import Events from '@/api/Events'

// Server-side stats provider for the column stats popover. Event Search counts
// over the whole index, so the terms come from OpenSearch rather than from the
// rows on screen (contrast: Selector Search counts its bounded rows client-side
// via utils/columnStats).

/**
 * Build a stats provider bound to a query scope.
 * @param {{query?: string, logTypes?: string[], sources?: string[], size?: number}} scope
 * @returns {(field: string) => Promise<{terms: Array<{value: *, count: number}>, cardinality: ?number}>}
 */
export function makeServerTermsProvider({ query = '*', logTypes = [], sources = [], size = 10 } = {}) {
  return async (field) => {
    const res = await Events.aggregate(
      query,
      logTypes,
      field,
      ['terms', 'cardinality'],
      size,
      null, // backgroundFilter
      null, // compositeFields
      sources
    )

    // Events.aggregate resolves with a status envelope instead of throwing, so
    // translate failures into a rejection for the popover's error branch.
    if (res.status !== 'success' || !res.data) {
      throw new Error(res.message || 'Failed to load aggregations')
    }

    return {
      terms: res.data.terms || [],
      cardinality: res.data.cardinality ?? null
    }
  }
}
